import {useTileAnimation, type TileProps} from './types'

export const Tile5 = ({className, colors, delay}: TileProps) => {
  const svgRef = useTileAnimation({
    delay,
    selector: 'g rect',
    scaleProperty: 'scale',
    transformOrigin: 'center',
  })

  return (
    <svg
      ref={svgRef}
      className={className}
      width="400"
      height="146"
      viewBox="0 0 400 146"
      fill="none"
      aria-hidden="true"
    >
      <g clipPath="url(#page-divider-tile-5-clip)">
        <rect width="402" height="146" transform="matrix(-1 0 0 1 402 0)" fill={colors[0]} />
        <rect width="54.7304" height="54.7293" transform="matrix(-1 0 0 1 111.926 -8.58325)" fill={colors[1]} />
        <rect width="54.7304" height="54.7293" transform="matrix(-1 0 0 1 164.971 46.0308)" fill={colors[1]} />
        <rect width="54.7304" height="54.7293" transform="matrix(-1 0 0 1 111.926 100.752)" fill={colors[1]} />
        <rect width="54.7304" height="54.7293" transform="matrix(-1 0 0 1 274.592 -8.58325)" fill={colors[1]} />
        <rect width="54.7304" height="54.7293" transform="matrix(-1 0 0 1 329.306 46.0308)" fill={colors[1]} />
        <rect width="54.7304" height="54.7293" transform="matrix(-1 0 0 1 274.592 100.752)" fill={colors[1]} />
      </g>
      <defs>
        <clipPath id="page-divider-tile-5-clip">
          <rect width="402" height="146" fill="white" transform="matrix(-1 0 0 1 402 0)" />
        </clipPath>
      </defs>
    </svg>
  )
}
